export const environment = {
  environmentLabel: 'dev',
  landingUrl: 'https://primeaccessinc.com/',
  apiBaseUrl: 'https://api.primeaccessinc.dev/api/',
  googlePlaceKey: 'AIzaSyCuRqPD-V6St_Ih6R22D9ZF8abym2ROtMg',
  production: false,
};
